export const DRAWER_WIDTH = 240;
export const CONTENT_MAX_WIDTH = 1280;
